import React from 'react';

// Redux hooks and selectors
import { useAppSelector } from '../../redux/hooks/useAppSelector';
import { useAppDispatch } from '../../redux/hooks/useAppDispatch';
import { selectIsSidebarOpen } from '../../redux/selectors/displaySettingsSelectors';

// Flowbite UI components and icons
import { Sidebar as FbSidebar } from 'flowbite-react';

// Custom components
import { ItemsGroup } from './ItemsGroup';
import { toggleSidebar } from '../../redux/slices/displaySettingsSlice';
import { HiOutlineX } from 'react-icons/hi';

export const Sidebar: React.FC = () => {
  const dispatch = useAppDispatch();
  const isSidebarOpen = useAppSelector(selectIsSidebarOpen);

  return (
    <>
      <button
        className={`fixed inset-0 bg-primary-900/80 lg:hidden ${isSidebarOpen ? 'z-40' : 'hidden'}`}
        onClick={() => dispatch(toggleSidebar())}
      >
        <span className="sr-only">close</span>
      </button>
      <FbSidebar
        className={`sidebar bg-primary-100 text-gray-900 shadow-lg dark:text-primary-25 ${isSidebarOpen ? 'z-50' : 'sidebar__closed'}`}
      >
        {isSidebarOpen && (
          <div className="flex items-end justify-end lg:hidden">
            <button
              className="rounded p-3 text-gray-900 transition-colors hover:bg-primary-600 active:bg-primary-500 dark:text-primary-25 dark:hover:bg-primary-800 dark:active:bg-primary-800"
              onClick={() => dispatch(toggleSidebar())}
            >
              <HiOutlineX />
            </button>
          </div>
        )}
        <FbSidebar.Items>
          <ItemsGroup />
        </FbSidebar.Items>
      </FbSidebar>
    </>
  );
};
